export default __webpack_public_path__ + "static/media/home-tab-icon.0c74313e.svg";